import { gql } from 'urql';

const TabaPayLicense = gql`
  query GetTabaPayLicense($version: String!) {
    licenses {
      web {
        tabaPay(version: $version) {
          key
        }
      }
    }
  }
`;

export default TabaPayLicense;
